import { render, staticRenderFns } from "./WorkTypeAdd.vue?vue&type=template&id=25cbe96f&scoped=true"
import script from "./WorkTypeAdd.vue?vue&type=script&lang=js"
export * from "./WorkTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cbe96f",
  null
  
)

export default component.exports